import React, { useContext, useEffect, useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import {
  GET_BUSINESS_BY_ID_ENDPOINT,
  GET_PLANS_ENDPOINT,
} from "../helpers/endpoints";
import PlanDetail from "../components/PlanDetail";
import "../styles/homeStyles.css";
import HomePlaceholder from "./HomePlaceholder";
import { useNavigate, useParams } from "react-router-dom";
import {
  PurchaseContext,
  isValidBusinessId,
} from "../context/PurchaseContext";
import { PURCHASE_URL } from "../helpers/routes";

const Home = () => {
  let { businessId } = useParams();
  const [plansMapByCategory, setPlansMapByCategory] = useState({});
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { fetchBusiness } = useContext(PurchaseContext);

  useEffect(() => {
    getPlans();
    if (isValidBusinessId(businessId)) {
      fetchBusiness(businessId);
    }
  }, []);

  const getPlans = async () => {
    fetch(GET_PLANS_ENDPOINT, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setLoading(false);
        const plansByCategory = data.reduce((map, item) => {
          const { categoria } = item;
          if (!map[categoria.nombre]) {
            map[categoria.nombre] = [];
          }
          map[categoria.nombre].push(item);
          return map;
        }, {});
        setPlansMapByCategory(plansByCategory);
      })
      .catch((error) => console.log(error));
  };

  return (
    <Container fluid style={{ backgroundColor: "#ECECEC" }}>
      {loading ? (
        <HomePlaceholder />
      ) : (
        <>
          {Object.keys(plansMapByCategory).map((key) => (
            <Row key={key}>
              <Container
                className="d-flex align-items-center card-container mb-3"
                style={{ backgroundColor: "#257CFF" }}
              >
                <Card
                  style={{ backgroundColor: "#257CFF", border: "none" }}
                  className="p-5"
                >
                  <Card.Body>
                    <h1 style={{ color: "yellow" }}>Planes para negocios de </h1>
                    <h1 style={{ color: "white" }}>{key}</h1>
                  </Card.Body>
                </Card>
              </Container>

              <Row className="p-5">
                {plansMapByCategory[key].map((plan) => (
                  <Col
                    key={plan.uuid}
                    sm={12}
                    md={6}
                    lg={3}
                    className="ml-5 mr-5 p-3"
                  >
                    <PlanDetail
                      key={plan.id}
                      nombre={plan.nombre}
                      precio={plan.precio}
                      tipo={plan.tipoPlanVenta}
                      diasVigencia={plan.diasVigencia}
                      tag={plan.tag}
                      descripciones={plan.descripciones}
                      onClickBuyCallback={() => {
                        navigate(`${PURCHASE_URL}/${plan.uuid}`);
                      }}
                    />
                  </Col>
                ))}
              </Row>
            </Row>
          ))}
        </>
      )}
    </Container>
  );
};

export default Home;
